<div class="dialog">
    <div *ngIf="data.icon" class="icon-container">
        <div class="icon" [ngClass]="data.icon"></div>
    </div>
    <h2 *ngIf="data.title">{{ data.title }}</h2>
    <div mat-dialog-content class="content">
    <p>{{ data.question }}</p>
    </div>
    <div 
        mat-dialog-actions 
        [ngStyle]="{'justify-content': data.align ? data.align : 'space-around'}"
    >
    <button mat-button (click)="onNoClick()">{{ data.no }}</button>
    <button 
        mat-button 
        [mat-dialog-close]="true"
        [ngStyle]="{'background-color': data.backgroundColor ? data.backgroundColor : ''}"
    >{{ data.yes }}</button>
    </div>
</div>